import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { VariablesConstant } from "../../constants/variables";

export default function FunctionButton(props: any) {
  const { t, i18n } = useTranslation();
  const [isActive, setIsActive] = useState<any>(false);
  const [scrollVisible, setScrollVisible] = useState<any>(false);
  const buttonRef = useRef<any>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrollVisible(true);
      } else {
        setScrollVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <>
      {!isActive ? (
        <button className={"function-btn close" + (scrollVisible ? " scroll" : "")} onClick={handleClick}>
          <i className="pi pi-plus"></i>
        </button>
      ) : (
        <>
          <div className={"function-btn-lst"  + (scrollVisible ? " scroll" : "")} ref={buttonRef}>
            {props.currView === VariablesConstant.VIEW_LST_CONNECTION && (
              <button type="button" onClick={() => props.onAdd()} className="custom-btn btn-rounded btn-dark mb-2">
                <i className="pi pi-plus fs-16 me-2"></i>
                {t("sample.label.button.add")}
              </button>
            )}
            {props.currView === VariablesConstant.VIEW_DETAILS_CONNECTION && (
              <>
                <button type="button" onClick={() => props.onAdd()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-plus fs-16 me-2"></i>
                  {t("sample.label.button.add")}
                </button>
                <button type="button" onClick={() => props.onClone()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-clone fs-16 me-2"></i>
                  {t("sample.label.button.clone")}
                </button>
                <button type="button" onClick={() => props.onList()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-bars fs-16 me-2"></i>
                  {t("sample.label.button.list")}
                </button>
              </>
            )}
            {props.currView === VariablesConstant.DATA_MAP_FORM && (
              <>
                <button type="button" onClick={() => props.onAdd()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-plus fs-16 me-2"></i>
                  {t("sample.label.button.add")}
                </button>
                <button type="button" onClick={() => props.onSave()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-save fs-16 me-2"></i>
                  {t("dcs0201.btn.save")}
                </button>
                <button type="button" onClick={() => props.onList()} className="custom-btn btn-rounded btn-dark mb-2">
                  <i className="pi pi-bars fs-16 me-2"></i>
                  {t("sample.label.button.list")}
                </button>
              </>
            )}
          </div>
          <button className={"function-btn open" + (scrollVisible ? " scroll" : "")} onClick={handleClick}>
            <i className="pi pi-minus"></i>
          </button>
        </>
      )}
    </>
  );
}
